export const hasFeatureRole = ({ employeeRoles = [], targetRoleKey = '' }) => (
  employeeRoles.some((role) => role.key === targetRoleKey)
);
